import { useEffect } from "react"
import {  useSelector } from "react-redux"


export const GTMTrigger = () => {
   
    const createBookingResponse = useSelector(state => state.createBooking);
    const gtm = useSelector(state => state.gtm);
    

    

    useEffect(() => {
        
    if(createBookingResponse && !gtm.load===false ){
        
       
        if(!gtm.load === false){
            
            
            // console.log(gtm)
        }
        return () => {
            // Optional cleanup mechanism for effects
            
            // console.log('Component will unmount');
          };
    }
    // eslint-disable-next-line 
    }, [])

    return(
        <>
        </>
    )
}